import React from 'react';
import { createRoot } from 'react-dom/client';
import CallbackRequestForm from './components/CallbackRequestForm.jsx';
import JobApplicationForm from './components/JobApplicationForm.jsx';
import IceaLionAcademyForm from './components/IceaLionAcademyForm.jsx';
import './index.css';

/*
 * Callback Request Form Custom Element
 */
class CallbackRequestFormElement extends HTMLElement {
  constructor() {
    super();
    this._root = null;
  }

  connectedCallback() {
    if (!this._root) {
      this._root = createRoot(this);
      this._root.render(<CallbackRequestForm requestType={this.getAttribute('requestType')} />);
    }
  }

  disconnectedCallback() {
    if (this._root) {
      this._root.unmount();
      this._root = null;
    }
  }
}

/*
 * Job Application Form Custom Element
 */
class JobApplicationFormElement extends HTMLElement {
  constructor() {
    super();
    this._root = null;
  }

  connectedCallback() {
    if (!this._root) {
      this._root = createRoot(this);
      this._root.render(<JobApplicationForm ourAgencyForceForm={this.getAttribute('ourAgencyForceForm')} />);
    }
  }

  disconnectedCallback() {
    if (this._root) {
      this._root.unmount();
      this._root = null;
    }
  }
}

/*
 * ICEA Lion Academy Form Custom Element
 */
class IceaLionAcademyFormElement extends HTMLElement {
  constructor() {
    super();
    this._root = null;
  }

  connectedCallback() {
    if (!this._root) {
      this._root = createRoot(this);
      this._root.render(<IceaLionAcademyForm />);
    }
  }

  disconnectedCallback() {
    if (this._root) {
      this._root.unmount();
      this._root = null;
    }
  }
}

// Register all custom elements
const CALLBACK_ELEMENT_NAME = 'icea-lion-callback-form';
const JOB_ELEMENT_NAME = 'icea-lion-job-application';
const ACADEMY_ELEMENT_NAME = 'icea-lion-academy-form';

if (!customElements.get(CALLBACK_ELEMENT_NAME)) {
  customElements.define(CALLBACK_ELEMENT_NAME, CallbackRequestFormElement);
}

if (!customElements.get(JOB_ELEMENT_NAME)) {
  customElements.define(JOB_ELEMENT_NAME, JobApplicationFormElement);
}

if (!customElements.get(ACADEMY_ELEMENT_NAME)) {
  customElements.define(ACADEMY_ELEMENT_NAME, IceaLionAcademyFormElement);
}